// This file should only contain action type constants.

export const SET_ITEMS = 'SET_ITEMS';
